import { createContext, useContext, useState } from 'react';

export const AppContext = createContext<{
  activeView: 'total' | 'checkedIn' | 'checkedOut' | 'pending';
  setActiveView: (view: 'total' | 'checkedIn' | 'checkedOut' | 'pending') => void;
  printerId: number;
  setPrinterId: (printerId: number) => void;
  adminMode: boolean;
  setAdminMode: (adminMode: boolean) => void;
}>({
  activeView: 'total',
  setActiveView: () => { },
  printerId: 0,
  setPrinterId: () => { },
  adminMode: false,
  setAdminMode: () => { },
});

export const AppContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeView, setActiveView] = useState<'total' | 'checkedIn' | 'checkedOut' | 'pending'>('total');
  const [printerId, setPrinterId] = useState<number>(0);
  const [adminMode, setAdminMode] = useState<boolean>(false);

  const context = {
    activeView,
    setActiveView,
    printerId,
    setPrinterId,
    adminMode,
    setAdminMode,
  };

  return (
    <AppContext.Provider value={context}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
